module.exports = __webpack_public_path__ + "img/green.6974198e.png";